import { useState, useEffect } from 'react'; 
import { useStepContext } from "../../utils/StepContext.jsx"; 
import { useFormContext } from "../../utils/FormContext.jsx"; 
import { useMediaQuery } from 'react-responsive';
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"; 

import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";
import InfoSVG from '../../assets/InfoSVG.jsx'; 

const Title = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, formId, handleTitleChange, handleOECPaymentOtherInputChange } = useFormContext(); 
    const { token, user } = useAuth(); 
    const [isAssistVisible, setIsAssistVisible] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const currentPageValue = 2;
    const currentSubStepProgress = 1/7; 

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750} gap={0}>
        <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
            <div className="inline-flex w-full justify-between">
            {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Title</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Title</h3>}
                <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                    <HelpButton onClick={toggleAssist}/>
                    <SaveButton formData={formData} formId={formId}/>
                    {user && <PDFPreview formData={formData}/> }
                </div>
            </div>
            <div className="flex flex-col gap-2 w-full text-left pl-2 md:pl-0 mb-8">
                <div className="w-[330px] md:w-[450px] justify-between items-start flex flex-col mt-4">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>
                        Will the seller select the title insurance company?
                    </span>
                    <span className='text-[13px] md:text-sm text-slate-500 font-[Inter]'>
                        Recommended: Yes
                    </span>
                </div>
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="sellerYes" 
                            value="yes" 
                            checked={formData.sellerSelectsTitleCo === 'yes'} 
                            onChange={(e) => handleTitleChange('sellerSelectsTitleCo', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="sellerNo"
                            value="no" 
                            checked={formData.sellerSelectsTitleCo === 'no'} 
                            onChange={(e) => handleTitleChange('sellerSelectsTitleCo', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
            </div>
            <div className="flex flex-col w-full text-left pl-2 md:pl-0 mb-8">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Will title contain owner's extended coverage (OEC)?</span>
                <span className="w-full mb-2 text-shi-purple text-[13px] md:text-sm font-['Inter']">Enhanced title protection. May require ILC/Survey payment in the Next Step</span>
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="oecYes" 
                            value="yes" 
                            checked={formData.ownersExtendedCoverage === 'yes'} 
                            onChange={(e) => handleTitleChange('ownersExtendedCoverage', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Yes</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="oecNo"
                            value="no" 
                            checked={formData.ownersExtendedCoverage === 'no'} 
                            onChange={(e) => handleTitleChange('ownersExtendedCoverage', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">No</label>
                    </div>
                </div>
            </div>
            {formData.ownersExtendedCoverage === 'yes' && (
            <div className="flex flex-col gap-2 w-full text-left pl-2 md:pl-0 mb-8">
                <div className="flex flex-col mb-2">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Who Will Pay the OEC?</span>
                    <span className='text-[13px] md:text-sm text-slate-500 font-[Inter]'>Recommended: Seller</span>
                </div>
                <div className="self-stretch justify-start gap-[10px] md:gap-[25px] flex-wrap inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="buyer" 
                            value="buyer" 
                            checked={formData.oecPayment === 'buyer'} 
                            onChange={(e) => handleTitleChange('oecPayment', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="seller"
                            value="seller" 
                            checked={formData.oecPayment === 'seller'} 
                            onChange={(e) => handleTitleChange('oecPayment', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="halfandhalf"
                            value="half" 
                            checked={formData.oecPayment === 'half'} 
                            onChange={(e) => handleTitleChange('oecPayment', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Half Buyer / Half Seller</label>
                    </div>
                    <div className="inline-flex justify-between">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="other"
                            value="other" 
                            checked={formData.oecPayment === 'other'} 
                            onChange={(e) => handleTitleChange('oecPayment', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Other</label>
                        <input 
                                type="text"
                                name="oecPaymentOther"
                                className="text-left pl-2 w-[230px] border border-shi-gray rounded-md h-[30px] bg-white border-slate-300 justify-start items-center gap-2.5 flex"
                                placeholder=""
                                value={formData.oecPaymentOther}
                                onChange={handleOECPaymentOtherInputChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
            )}

            <div className="flex flex-col w-full text-left pl-2 md:pl-0 mb-8">
            <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Title transfer</span>
            <div className="border-blue-500 bg-blue-50 border rounded-md md:p-2 p-1 inline-flex justify-between w-full gap-2 mb-4 items-center">
                {isMobile ? <InfoSVG width={18} height={18} fill='#2563EB'/> : <InfoSVG width={23} height={23} fill='#2563EB'/>}
                <span className="w-full text-blue-800 text-[13px]">Recommended: General Warranty. A General warranty deed means the seller warrants against anything any owner of the property ever did to incur debt or liens on the title. A special warranty deed means the seller only warrants against anything the seller did to incur debt or liens.</span>
            </div>
                <div className="self-stretch justify-start gap-[10px] md:gap-[25px] flex-wrap inline-flex items-center mt-2">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="generalWarranty"
                            value="generalWarranty" 
                            checked={formData.transferOfTitle === 'generalWarranty'} 
                            onChange={(e) => handleTitleChange('transferOfTitle', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">General Warranty Deed</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="specialWarranty" 
                            value="specialWarranty" 
                            checked={formData.transferOfTitle === 'specialWarranty'} 
                            onChange={(e) => handleTitleChange('transferOfTitle', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Special Warranty Deed</label>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-2 w-full text-left pl-2 md:pl-0 mb-8">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Less common title transfer options</span>
                {/* <span className="w-[600px] h-auto text-shi-purple mt-2 text-xs font-['Inter']">Typically marked "Special Warranty". A General warranty deed means the seller warrants against anything any owner of the property ever did to incur debt or liens on the title. A special warranty deed means the seller only warrants against anything the seller did to incur debt or liens.</span> */}
                <div className="self-stretch justify-start flex-wrap gap-[10px] md:gap-[25px] inline-flex items-center mt-2">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="BargainAndSale" 
                            value="BargainAndSale" 
                            checked={formData.transferOfTitle === 'BargainAndSale'} 
                            onChange={(e) => handleTitleChange('transferOfTitle', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Bargain and Sale Deed</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="quitClaim"
                            value="quitClaim" 
                            checked={formData.transferOfTitle === 'quitClaim'} 
                            onChange={(e) => handleTitleChange('transferOfTitle', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Quit Claim Deed</label>
                    </div>
                </div>
                <div className="self-stretch justify-start flex-wrap gap-[10px]  md:gap-[25px] inline-flex items-center mt-2">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="PersonalRepresentative" 
                            value="PersonalRepresentative" 
                            checked={formData.transferOfTitle === 'PersonalRepresentative'} 
                            onChange={(e) => handleTitleChange('transferOfTitle', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Personal Representative's Deed</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="otherDeed"
                            value="otherDeed" 
                            checked={formData.transferOfTitle === 'otherDeed'} 
                            onChange={(e) => handleTitleChange('transferOfTitle', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Other Deed</label>
                        <input 
                                type="text"
                                name="transferOfTitleOther"
                                className="text-left pl-2 w-[230px] border border-shi-gray rounded-md h-[30px] bg-white border-slate-300 justify-start items-center gap-2.5 flex"
                                placeholder=""
                                value={formData.transferOfTitleOther}
                                onChange={handleOECPaymentOtherInputChange}
                            />
                    </div>
                </div>
            </div>
            </div>

            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>

        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}

        </div>
        
    )
}

export default Title; 